export default __webpack_public_path__ + "static/media/background-profile.d0a3dd50.png";